function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.5,1 L10,1 C10,0.447 9.553,0 9,0 L7,0 C6.447,0 6,0.447 6,1 L5.5,1 C5.224,1 5,1.224 5,1.5 L5,2.5 C5,2.776 5.224,3 5.5,3 L10.5,3 C10.776,3 11,2.776 11,2.5 L11,1.5 C11,1.224 10.776,1 10.5,1 M12,16.5 L12,15.5 C12,15.224 11.776,15 11.5,15 L4.5,15 C4.224,15 4,15.224 4,15.5 L4,16.5 C4,16.776 4.224,17 4.5,17 L11.5,17 C11.776,17 12,16.776 12,16.5 M12,8.5 L12,7.5 C12,7.224 11.776,7 11.5,7 L4.5,7 C4.224,7 4,7.224 4,7.5 L4,8.5 C4,8.776 4.224,9 4.5,9 L11.5,9 C11.776,9 12,8.776 12,8.5 M12,12.5 L12,11.5 C12,11.224 11.776,11 11.5,11 L4.5,11 C4.224,11 4,11.224 4,11.5 L4,12.5 C4,12.776 4.224,13 4.5,13 L11.5,13 C11.776,13 12,12.776 12,12.5 M16,2.935 L16,19.065 C16,19.581 15.581,20 15.065,20 L1,20 C0.447,20 0,19.553 0,19 L0,2.935 C0,2.419 0.419,2 0.935,2 L3.75,2 C3.888,2 4,2.112 4,2.25 L4,2.75 C4,3.44 4.56,4 5.25,4 L10.75,4 C11.44,4 12,3.44 12,2.75 L12,2.25 C12,2.112 12.112,2 12.25,2 L15.065,2 C15.581,2 16,2.419 16,2.935",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-2 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/line_copy.58e6175e.svg";
export { SvgComponent as ReactComponent };